module.exports = __webpack_public_path__ + "img/status_down.dfe30cce.png";